import type { Entity } from '../../entity/index'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

type OccupantValueOrNull = Entity | null

// an occupant is a unit that occupies a position {x, y}
// at the same layer as the current unit
export default function createOccupantValueGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
) {
  const data : Array<OccupantValueOrNull> = new Array(gridWidth * gridHeight)
  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      data[index] = null
      if (positionStack) {
        for (let index = 0; index < positionStack.length; index++) {
          const ent = positionStack[index]
          if (ent.taxi_id) {
            continue
          } else if (ent.layer_id === unit.layer_id) {
            data[index] = ent
          }
        }
      }
    }
  }
  return data
}
